<rt-dropdown>
  <rt-date-picker
    [value]="date"
    [useYearNav]="useYearNav"
    [direction]="direction"
    [blackout]="blackoutDates"
    [attr.padding-bottom]="!showClear ? '' : null"
    (click)="$event.preventDefault()"
    (valueChange)="onDateChange($any($event))"
  >
  </rt-date-picker>
  @if (showClear) {
    <div layout-justify-center layout>
      <div margin-tb-medium>
        <rt-button
          variant="plain"
          (click)="onDateChange('')"
          class="clear-button"
          layout-full-width
        >
          <rt-icon name="close"></rt-icon>
          <span>{{ 'app.common.clear' | translate }}</span>
        </rt-button>
      </div>
    </div>
  }
</rt-dropdown>
